"use client";

import { useEffect, useState } from "react";

export function AppUpdateBanner() {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    if (!("serviceWorker" in navigator)) return;

    // Fires when a new SW takes control (skipWaiting + clientsClaim triggered it)
    const handleControllerChange = () => setShowBanner(true);

    navigator.serviceWorker.addEventListener(
      "controllerchange",
      handleControllerChange,
    );

    return () => {
      navigator.serviceWorker.removeEventListener(
        "controllerchange",
        handleControllerChange,
      );
    };
  }, []);

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-4 left-1/2 z-50 flex -translate-x-1/2 items-center gap-3 rounded-xl border border-emerald-200 bg-white px-5 py-3 shadow-lg">
      <span className="text-sm font-medium text-slate-700">
        A new version is available
      </span>
      <button
        onClick={() => window.location.reload()}
        className="rounded-lg bg-emerald-600 px-3 py-1.5 text-xs font-semibold text-white hover:bg-emerald-700"
      >
        Update now
      </button>
    </div>
  );
}
